var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte-Mobile",
    transform: "translate(-325.000000, -1581.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(0.000000, 1480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Icon",
    transform: "translate(326.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jurica-koletic-7YVZYZeITc8-unsplash"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#AFAFB1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    stroke: "#AFAFB1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "profileTrigger",
    d: "M12,14 C12,11 9,10 6,10 C3,10 0,11 0,14",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "profileTrigger",
    id: "Oval",
    cx: 6,
    cy: 4,
    r: 3
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.ae86e9950b177b77fbdc71516bfddc4f.svg";
export { ForwardRef as ReactComponent };